import loginedApi from "../apis";
import { FETCH_APPOINTMENT_HISTORY, FETCH_SELECTED_APPOINTMENT_DETAILS } from "./type";
import specialist from "../specialityList";
import authHeader from './auth-header';
import CryptoJS from "crypto-js";
const publicIp = require("public-ip");

let IP = publicIp.v4();
const { detect } = require('detect-browser');
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);


  

export const fetchAppointmentHistory = (userData,offset) => async (dispatch) => {

    let resp = await loginedApi.post("getcountrycode", 
    {
     "token":hashcode.toString(),
      "version":"2.0",
      "data": {"browserTimeZone":"GMT%2B05:30"},
      "requestType": 1058
  });
  const doctorscountrycode = resp.data.data;


    const res = await loginedApi.post("getappointmenthistory", {

       token :hashcode.toString(),
        version: "2.0",
        data: {
            browserTimeZone: `GMT${formatTime}`,
            patientId:userData?.userId, //"48315460",
            Ipaddress: doctorscountrycode.Ipaddress, 
            useragent: userAgent,
            Browser: browser.name+" "+browser.version,
            appname: "C2MD Web",
            Os: platform ,
            offset:offset,
           accessCountry: doctorscountrycode.Country,
        },
        "requestType": 58,
    },{ headers: authHeader() });

    console.log("getappointmenthistory",res);


    if (res.status === 200) {
        
        dispatch({
            type: FETCH_APPOINTMENT_HISTORY,
            payload: res.data.data,
        });
        return res

    }
};


export const fetchSelectedAppointmentDetails = ({ appointmentId,userData}) => async (dispatch) => {

    let resp = await loginedApi.post("getcountrycode", 
    {
     "token":hashcode.toString(),
      "version":"2.0",
      "data": {"browserTimeZone":"GMT%2B05:30"},
      "requestType": 1058
  });
  const doctorscountrycode = resp.data.data;

    const res = await loginedApi.post("appointments",
        {
            "requestType": "77",
            token :hashcode.toString(),
            "version":"2.0",
            "data": {
                "appointmentId": appointmentId,
                "userType": userData?.userType,
                browserTimeZone: `GMT${formatTime}`,
                "userId": userData?.userId,
                "currency": userData?.today_rate.currency,
                Browser: browser.name+" "+browser.version,
                appname: "C2MD Web",
                Ipaddress: doctorscountrycode.Ipaddress, 
                useragent: userAgent,
            }
        }
    );

    console.log(res);

    if (res.status === 200) {
        dispatch({
            type: FETCH_SELECTED_APPOINTMENT_DETAILS,
            payload: res.data.data,
        });
        return res.data.data;
    }
};



